import { render, staticRenderFns } from "./MoleculePopupResult.vue?vue&type=template&id=6608b59d&"
import script from "./MoleculePopupResult.vue?vue&type=script&lang=js&"
export * from "./MoleculePopupResult.vue?vue&type=script&lang=js&"
import style0 from "./MoleculePopupResult.vue?vue&type=style&index=0&id=6608b59d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "@/lang/MoleculePopupResult.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fapp%2Fcomponents%2Fmolecules%2Fproject%2FMoleculePopupResult.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AtomsCommonAtomIcon: require('/app/components/atoms/common/AtomIcon.vue').default})
